import React from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '@Redux/detail/store';
import { I_Price, PriceStyles } from '@Redux/detail/Group/interfaces';
import cN from 'classnames';
import styles from '../styles.module.scss';
import { useTranslation } from 'react-i18next';

interface I_PriceItem {
    type: string;
    Price: number;
    PriceOrig: number;
}

const PriceList: React.FC = () => {
    const { GroupInfo, PricesInfo } = useSelector((state: RootState) => state.groupReducer);

    return (
        <ul className={cN(styles['price-list'], 'price-list')}>
            {/* 是國內團並且超過一天 才顯示房型 其他都顯示參團費 參團費顯示規則為雙人房型價格 */}
            {PricesInfo!.DirectPrice.map((items: I_Price, i: number) => {
                if (GroupInfo.IsForeign == false && GroupInfo.TourDays > 1) {
                    return PriceItemList(i, items, items.PriceStyle);
                } else {
                    if (items.PriceStyle == 2) {
                        return PriceItemList(i, items, 0);
                    }
                }
            })}
        </ul>
    );
};

export default PriceList;

/**************/
function PriceItemList(idx: number, item: I_Price, showText: number) {
    const { IsB2E, PricesInfo } = useSelector((state: RootState) => state.groupReducer);
    const { curPage } = useSelector((state: RootState) => state.pageReducer);
    const isPrint = curPage === 'print';
    const isDomesticDayTour = !PricesInfo!.IsForeign && PricesInfo!.TourDays === 1; // 國旅一日團
    return (
        <li key={idx} className={styles['price-item']}>
            <div className={cN(styles['price-item__container--title'], [isPrint ? 'title' : ''])}>
                <span>{PriceStyleToCH(showText)}</span>
                {IsB2E && (
                    <span className={styles['price-item__container--title__note']}>企業價</span>
                )}
            </div>
            <PriceItem
                type="大人"
                PriceOrig={item.AdultsPrice}
                Price={item.AdultsPrice}
            />
            <PriceItem
                type={!isDomesticDayTour ? '小孩佔床' : '小孩'}
                PriceOrig={item.ChildrenWithBed}
                Price={item.ChildrenWithBed}
            />
            {!isDomesticDayTour && (
                <>
                    <PriceItem
                        type="小孩不佔床"
                        PriceOrig={item.ChildrenNoPrice}
                        Price={item.ChildrenNoPrice}
                    />
                    <PriceItem
                        type="小孩加床"
                        PriceOrig={item.ChildrenExtraBed}
                        Price={item.ChildrenExtraBed}
                    />
                </>
            )}
            <PriceItem
                type="嬰兒"
                PriceOrig={item.BabyPrice}
                Price={item.BabyPrice}
            />
        </li>
    );
}

function PriceItem({ type, Price, PriceOrig }: I_PriceItem) {
    const { curPage } = useSelector((state: RootState) => state.pageReducer);
    const isPrint = curPage === 'print';
    return (
        <div className={cN(styles['price-item__container'], [isPrint ? 'container' : ''])}>
            <span className={cN(styles['price-item__type'], [isPrint ? 'type' : ''])}>{type}</span>
            <span className={cN(styles['price-item__price'], [isPrint ? 'sell-price' : ''])}>
                {ShowPrice(Price, PriceOrig)}
            </span>
        </div>
    );
}

function ShowPrice(price: number, PriceOrig?: number) {
    const { GroupInfo, PricesInfo, IsB2E } = useSelector((state: RootState) => state.groupReducer);
    const dataOrig = IsB2E ? `${PriceOrig === 0 ? '' : PriceOrig}` : '';
    const formattedPrice = Number(price).toLocaleString();

    if(!price) return '--';

    return (
        <span data-orig={dataOrig}>
            {GroupInfo.Status == 6
                ? '近期上架'
                : `${formattedPrice}${PricesInfo?.TravelType == 2 ? '起' : ''}`}
        </span>
    );
}

function PriceStyleToCH(style: PriceStyles) {
    const { t } = useTranslation();
    switch (style) {
        case PriceStyles.Participation:
            return t('groupFee');
        case PriceStyles.Single:
            return '單人房';
        case PriceStyles.Double:
            return '雙人房';
        case PriceStyles.Triple:
            return '三人房';
        case PriceStyles.Quadruple:
            return '四人房';
    }
}
